import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Hook to track page views on route change
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available and cookie consent includes analytics
    if (typeof window !== 'undefined' && window.gtag) {
      try {
        const consent = JSON.parse(localStorage.getItem('cookieConsent'));
        if (consent && consent.analytics) {
          window.gtag('event', 'page_view', {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title
          });
        }
      } catch (e) {
        // No consent data, don't track
      }
    }
  }, [location]);
};

export default usePageTracking;
